import { Action } from 'redux';

import { FetchRecommendationsSucceeded } from '../../app/actions/AppActionTypes';
import { isActionFactory } from '../../app/actions/isActionFactory';
import { ListResult } from '../../ts/fetchers/ListResult';
import { IContentInfo } from '../../ts/models/IContentInfo';

export interface FetchRecommendationsSucceededAction extends Action {
  readonly result: ListResult<IContentInfo>;
}

export function getFetchRecommendationsSucceededAction(result: ListResult<IContentInfo>): FetchRecommendationsSucceededAction {
  return {
    type: FetchRecommendationsSucceeded,
    result
  };
}

export const isFetchRecommendationsSucceededAction = isActionFactory<FetchRecommendationsSucceededAction>(FetchRecommendationsSucceeded);

